import captureApi from "../api/CaptureApi";

export default {
    namespaced: true,
    state:{
        capture: {}
    },
    mutations:{
        setCapture(state, capture) {
            state.capture = capture;
        }
    },
    actions: {
        captureAllAction({commit}){
            captureApi.captureAll()
                .then(res => {
                    commit('setCapture',res.data)
                })
        }
    }
}
